import React, { useState, useEffect } from 'react';
import { createQuestion, updateQuestion } from '../api/api';
import '../index.css';
import './UserForm.css'; // Reuse UserForm CSS
import Form from './common/Form';
import Input from './common/Input';
import Button from './common/Button';
import Error from './common/Error';

const QuestionForm = ({ question, onClose, onQuestionUpdated, onQuestionCreated }) => {
    const [formData, setFormData] = useState({
        question: '',
        answer: '',
    });
    const [isEditing, setIsEditing] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (question) {
            setIsEditing(true);
            setFormData({
                question: question.question,
                answer: question.answer,
            });
        }
    }, [question]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setMessage("");

        try {
            if (isEditing) {
                const updatedQuestion = await updateQuestion(question.id, formData);
                if (updatedQuestion) {
                    onQuestionUpdated(updatedQuestion);
                    setMessage("Pregunta actualizada");
                }
            } else {
                const newQuestion = await createQuestion(formData);
                onQuestionCreated(newQuestion);
                setMessage("Pregunta creada");
            }
            setTimeout(() => {
                onClose();
            }, 1500);
        } catch (err) {
            setError(err.message || 'Error al procesar la pregunta');
        }
    };

    return (
        <Form className='form-user' onSubmit={handleSubmit}>
            {message && <div className='container-message'>{message}</div>}
            {error && <Error error={error} />}
            <Input type="text" id="question" name="question" value={formData.question} onChange={handleChange} label="Pregunta" required />
            <Input type="text" id="answer" name="answer" value={formData.answer} onChange={handleChange} label="Respuesta" required />

            <Button type="submit">{isEditing ? 'Actualizar' : 'Crear'}</Button>
            <Button type='button' onClick={onClose}>Cancelar</Button>
        </Form>
    );
};

export default QuestionForm;
